{
  "rememberMe": "Recordarme",
  "signIn": "Iniciar sesión",
  "signUp": "Crear una cuenta",
  "signUpLink": "¿No tienes una cuenta?",
  "continueAsGuest": "Continuar como invitado",
  "forgotPassword": "Olvidé mi contraseña",
  "forgotPasswordLink": "¿Olvidaste tu contraseña?",
  "setPassword": "Establecer contraseña",
  "codeVerification": "Verificación de código",
  "verifyMessage": "Enviamos un código de verificación a tu correo electrónico",
  "changePassword": "Cambiar contraseña",
  "signOut": "Cerrar sesión",
  "deleteAccount": "Eliminar cuenta",
  "availableProfiles": "Perfiles disponibles",
  "selectProfile": "Seleccionar perfil",
  "noProfiles": "No hay perfiles disponibles",
  "switchProfile": "Cambiar de perfil",
  "alreadyHaveCode": "¿Ya tienes un código de verificación?",
  "tempPassMessage": "Reemplaza tu contraseña temporal",
  "mfa": {
    "settings": "Configuración de MFA",
    "SMS": "SMS",
    "TOTP": "Aplicación de autenticación",
    "noPreference": "Sin preferencia",
    "enabledMFAMethods": "Métodos de MFA habilitados",
    "preferredMFAMethod": "Método de MFA preferido",
    "setupTOTPMFA": "Configurar MFA con aplicación de autenticación",
    "setupSMSMFA": "Configurar MFA por SMS",
    "disableTOTPMFA": "Desactivar MFA con aplicación de autenticación",
    "disableSMSMFA": "Desactivar MFA por SMS",
    "TOTPSetup": "Configuración de la aplicación de autenticación",
    "SMSSetup": "Configuración de SMS",
    "secretKey": "Clave secreta",
    "installAuthApp": "Instala una aplicación de autenticación en tu dispositivo móvil",
    "addAnAccount": "Agregar una cuenta",
    "scanQRCode": "Escanea el siguiente código QR:",
    "or": "O...",
    "addSecretManually": "Agrega la clave secreta manualmente en tu aplicación de autenticación:",
    "copySecretKey": "Copiar clave secreta",
    "regenSecretKey": "Regenerar clave secreta",
    "ensureAccountCreated": "Asegúrate de que se haya creado la cuenta '{appName}'",
    "verifySetup": "Verifica tu configuración:",
    "done": "Listo",
    "otpMessage": "Ingresa el código de un solo uso de tu aplicación de autenticación",
    "smsMessage": "Te enviamos un código de verificación por SMS",
    "setupAuthAppMessage": "¿Necesitas configurar tu aplicación de autenticación?",
    "signUpOptionalMobileMessage": "Si agregas tu número de celular, podrás usar SMS para la autenticación de múltiples factores (MFA). Si no agregas un número de celular, tendrás que configurar la MFA con una aplicación de autenticación (como Google Authenticator) la primera vez que inicies sesión.",
    "mfaSelectionHeader": "Selección de MFA",
    "mfaSelectionMessage": "Elige cómo quieres recibir tu código de un solo uso"
  },
  "ssoButtons": {
    "divider": "o",
    "continueSso": "Continuar con SSO",
    "continueMs": "Continuar con Microsoft",
    "continueGoogle": "Continuar con Google",
    "continueApple": "Continuar con Apple"
  }
}
